<div class="header">
  <ui-alert
    [message]="'Hier können Einkaufslisten erstellt, angesehen und gelöscht werden. Um Artikel einer Liste hinzuzufügen, klicken Sie auf das Einkaufslistensymbol eines Artikels (links neben “+” und “-”).'"
    [showIconInfo]="false"
    [theme]="'info'"
  ></ui-alert>
  <ui-page-header [boxed]="false">Einkaufslisten</ui-page-header>
  <p>Einkaufslisten helfen Ihnen, Artikel, die Sie häufig bestellen, einfach aufzurufen. Sie können individuelle
    Einkaufslisten anlegen.</p>
</div>

@if (loadingError()) {
  <ui-alert
    theme="error"
    message="Es ist ein Fehler beim laden der Einkaufsliste-Listen aufgetreten bitte versuchen Sie es erneut">
  </ui-alert>
} @else {
  <div class="actions">
    <ui-create-and-edit-shopping-list-dialog>
      <ui-button buttonStyle="text" icon="plus" iconStyle="light" type="button">Neue Liste</ui-button>
    </ui-create-and-edit-shopping-list-dialog>
  </div>

  @if (!shoppingListsLoading()) {
    @if (shoppingLists().length) {
      @if (isMobile()) {
        <ui-shopping-lists-mobile [shoppingLists]="shoppingLists()"></ui-shopping-lists-mobile>
      } @else {
        <ui-shopping-lists-desktop [shoppingLists]="shoppingLists()"></ui-shopping-lists-desktop>
      }
    } @else {
      <h3>Es sind keine Einkaufslisten für den gewählten Kunden verfügbar.</h3>
    }
  }
}
